<template>
    <div>

        <div class="articledetaile">
            <div>
               
            </div>
            <div v-show='animate' class="spinner">
                <div class="dot1"></div>
                <div class="dot2"></div>
            </div>
            <div v-show="!animate" class="detaile">
                <div class="content" ref="content" id="content">
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
  name: "articledetaile",
  data() {
    return {
     animate:true,
    };
  },
  methods: {
    getcontent() {
      this.axios
        .get(localStorage.getItem("detaile"))
        .then(res => {
         
          this.animate=false
          this.$refs.content.innerHTML =res.data.replace(/data-src/g, "src");
         
          this.article.forEach(cur=>{
              cur.image=(cur.image.substring(0,cur.image.lastIndexOf("?")));
           })
        })
        .catch(err => {

        });
    }
  },
  mounted() {
    this.getcontent();
  
   

  },
  activated() {
    this.getcontent();
  }
};
</script>

<style scoped>
.rich_media_content  p{
  font-size: 1rem;
  color:red !important
}
.js_article{
  font-size: 16px;
}
.detaile {
  padding: 10px;
  height: 100%;
}
.articledetaile {
  overflow-y: scroll;
}

.spinner {
  margin: 100px auto;
  width: 90px;
  height: 90px;
  position: relative;
  text-align: center;

  -webkit-animation: rotate 2s infinite linear;
  animation: rotate 2s infinite linear;
}

.dot1,
.dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #67cf22;
  border-radius: 100%;

  -webkit-animation: bounce 2s infinite ease-in-out;
  animation: bounce 2s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0px;
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes rotate {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/articledetaile.vue